(function($){
    $(function(){
        var chartData = [
            {
                value: parseInt(data.percentage_1),
                color:"#324A7F"
            },
            {
                value: parseInt(data.percentage_2),
                color: "#497333"
            },
            {
                value: parseInt(data.percentage_3),
                color: "#5E9C3D"
            },
            {
                value: parseInt(data.percentage_4),
                color: "#7DC256"
            },
            {
                value: parseInt(data.percentage_5),
                color: "#1B2844"
            }
        ];

        var canvas = document.getElementById("canvas");
        var ctx = canvas.getContext("2d");
        var midX = canvas.width/2;
        var midY = canvas.height/2;

        // function isScrolledIntoView ($elem) {
        //     var $window = $(window),
        //         docViewTop = $window.scrollTop(),
        //         docViewBottom = docViewTop + $window.height(),
        //         elemTop = $elem.offset().top,
        //         elemBottom = elemTop + $elem.height();
        
        //     return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop));
        // }
        
        $(document).on("scroll", animateDoughnut);

        function animateDoughnut() {
            var $canvas = $(canvas);
            if ($canvas.inViewport()) {
                // Create a pie chart
                $(document).off("scroll", animateDoughnut);
                var myPieChart = new Chart(ctx).Doughnut(chartData, {
                    showTooltips: false,
                    easing: 'easeInCirc',
                    onAnimationProgress: function() {
                        var radius = myPieChart.outerRadius;
                        for(var i=0; i<myPieChart.segments.length; i++) {
                            // Get needed variables
                            var value = myPieChart.segments[i].value;
                            var startAngle = myPieChart.segments[i].startAngle;
                            var endAngle = myPieChart.segments[i].endAngle;
                            var middleAngle = startAngle + ((endAngle - startAngle)/2);
        
                            var radiusFactor = 113/175;
        
                            // Compute text location
                            var posX = radius * radiusFactor * Math.cos(middleAngle) + midX;
                            var posY = radius * radiusFactor * Math.sin(middleAngle) + midY;
        
                            var img = document.getElementById('icon' + (i+1));
        
                            // Text offside by middle
                            var w_offset = img.width * 0.5;
                            var h_offset = img.height * 0.5;
        
                            ctx.drawImage(img, posX - w_offset, posY - h_offset);
                        }
                    },
                    percentageInnerCutout: 35
                });
            }
        }
    });
})(jQuery);
